module.exports = __webpack_public_path__ + "img/hy_m_img2.a595c53c.jpg";